import "./SiteConfigurationGroupNotificationsInfo.html";
import "./SiteConfigurationGroupNotificationsInfo.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";

// tslint:disable-next-line:max-line-length
import SiteConfigurationGroupNotificationsInfoComponentController from "./SiteConfigurationGroupNotificationsInfoComponentController";

export class SiteConfigurationGroupNotificationsInfoComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            subscriptions: "<",
        };
        this.controller = SiteConfigurationGroupNotificationsInfoComponentController;
        this.templateUrl =
            "/App/Components/Site/ConfigurationGroups/" +
            "Info/Notifications/SiteConfigurationGroupNotificationsInfo.html";
    }
}

module("mmManagePortal").component(
    "irSiteConfigurationGroupNotificationsInfo",
    new SiteConfigurationGroupNotificationsInfoComponent(),
);
